import { render, staticRenderFns } from "./ImprintView.vue?vue&type=template&id=5d53e0f4&scoped=true&"
import script from "./ImprintView.vue?vue&type=script&lang=js&"
export * from "./ImprintView.vue?vue&type=script&lang=js&"
import style0 from "./ImprintView.vue?vue&type=style&index=0&id=5d53e0f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d53e0f4",
  null
  
)

export default component.exports